export default API => ({
  // async getSports (store) {
  //   if (store.getters.sports.data.length) {
  //     return
  //   }
  //
  //   try {
  //     const res = await API.getSports()
  //     const {data, recordsFiltered} = res
  //
  //     store.commit('SET_SPORTS_LIST', {data, recordsFiltered})
  //   } catch (err) {
  //     throw err
  //   }
  // },
  // async getCountries (store) {
  //   if (store.getters.countries.data.length) {
  //     return
  //   }
  //
  //   try {
  //     const res = await API.getCountries()
  //     const {data, recordsFiltered} = res
  //
  //     store.commit('SET_COUNTRIES_LIST', {data, recordsFiltered})
  //   } catch (err) {
  //     throw err
  //   }
  // },
  // async getGenders (store) {
  //   if (store.getters.genders.data.length) {
  //     return
  //   }
  //
  //   try {
  //     const res = await API.getGenders()
  //     const {data, recordsFiltered} = res
  //
  //     store.commit('SET_GENDERS_LIST', {data, recordsFiltered})
  //   } catch (err) {
  //     throw err
  //   }
  // },
  // async getAges (store) {
  //   if (store.getters.ages.data.length) {
  //     return
  //   }
  //
  //   try {
  //     const res = await API.getAges()
  //     const {data, recordsFiltered} = res
  //
  //     store.commit('SET_AGES_LIST', {data, recordsFiltered})
  //   } catch (err) {
  //     throw err
  //   }
  // },
  // async getPartners (store) {
  //   if (store.getters.partners.data.length) {
  //     return
  //   }
  //
  //   try {
  //     const res = await API.getPartners()
  //     const {data, recordsFiltered} = res
  //
  //     store.commit('SET_PARTNERS_LIST', {data, recordsFiltered})
  //   } catch (err) {
  //     throw err
  //   }
  // },
  // async getRoles (store) {
  //   if (store.getters.roles.data.length) return
  //
  //   try {
  //     const res = await API.getRoles()
  //     const { data, recordsFiltered } = res
  //
  //     store.commit('SET_ROLES_LIST', { data, recordsFiltered })
  //   } catch (err) {
  //     throw err
  //   }
  // }
  async getReasons (store) {
    if (store.getters.reasons.data.length) {
      return
    }

    try {
      const res = await API.getReasons()
      const { data, recordsFiltered } = res

      store.commit('SET_REASONS_LIST', { data, recordsFiltered })
    } catch (err) {
      throw err
    }
  },
  async getAbilities (store) {
    if (store.getters.abilities.data.length) {
      return
    }

    try {
      const res = await API.getAbilities()
      const { data, recordsFiltered } = res

      store.commit('SET_ABILITIES_LIST', { data, recordsFiltered })
    } catch (err) {
      throw err
    }
  },
  async getWatermarks (store) {
    if (store.getters.watermarks.data.length) {
      return
    }

    try {
      const res = await API.getWatermarks()
      const { data, recordsFiltered } = res

      store.commit('SET_WATERMARKS_LIST', { data, recordsFiltered })
    } catch (err) {
      throw err
    }
  },
  async getSources (store) {
    if (store.getters.sources.data.length) {
      return
    }

    try {
      const res = await API.getSources()
      const { data, recordsFiltered } = res

      store.commit('SET_SOURCES_LIST', { data, recordsFiltered })
    } catch (err) {
      throw err
    }
  },
  async getRestreamersServers (store) {
    if (store.getters.restreamersServers.data.length) {
      return
    }

    try {
      const res = await API.getRestreamersServers()
      const { data, recordsFiltered } = res

      store.commit('SET_RESTREAMERS_SERVERS_LIST', { data, recordsFiltered })
    } catch (err) {
      throw err
    }
  },
  async getBells (store) {
    if (store.getters.bells.data.length) {
      return
    }

    try {
      const res = await API.getBells()
      const { data, recordsFiltered } = res

      store.commit('SET_BELLS_LIST', { data, recordsFiltered })
    } catch (err) {
      throw err
    }
  },
  async getSounds (store, page) {
    try {
      const res = await API.getSounds({ page })
      const { data, recordsFiltered } = res

      if (page > 1) {
        store.commit('UPDATE_BELLS_LIST', { data, recordsFiltered })
      } else {
        store.commit('SET_BELLS_LIST', { data, recordsFiltered })
      }
      return res
    } catch (err) {
      throw err
    }
  },
  async updateBellsList (store, startAt) {
    const { recordsFiltered, data } = await API.getBells({ start: startAt })

    const nextBells = []

    data.forEach(bell => {
      nextBells.push({
        id: bell.id,
        title: bell.title,
        soundUrl: bell.image_url
      })
    })

    store.commit('UPDATE_BELLS_LIST', { recordsFiltered, data: nextBells })
  },
  async getSound (store, id) {
    try {
      const res = await API.getSound(id)
      return res.data
    } catch (err) {
      throw err
    }
  },
  async resetBellsList (store) {
    try {
      const res = await API.getBells()
      const { data, recordsFiltered } = res

      store.commit('SET_BELLS_LIST', { data, recordsFiltered })
    } catch (err) {
      throw err
    }
  }
})
